<template>
    <div class="w-full mt-2">
        <div class="grid grid-cols-2 p-1 border-b border-light-primary">
            <div class="flex flex-col xl:grid xl:gap-1 xl:grid-cols-2 2xl:grid-cols-4 items-start border-r border-dotted border-light-primary px-3">
                <div class="flex justify-start py-0.5">
                    <div class="h-fit whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Prefix:</div>
                </div>
                <div class="flex space-x-1 2xl:col-span-3 w-full">
                    <input type="text" required class="p-1 border h-full w-full inline" v-model="contactData.prefix">
                </div>
                <div class="flex justify-start py-0.5">
                    <div class="h-fit whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">First Name:</div>
                </div>
                <div class="flex space-x-1 2xl:col-span-3 w-full">
                    <input type="text" required class="p-1 border h-full w-full inline" v-model="contactData.first_name">
                </div>
                <div class="flex justify-start py-0.5">
                    <div class="h-fit whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Middle Name:</div>
                </div>
                <div class="flex space-x-1 2xl:col-span-3 w-full">
                    <input type="text" required class="p-1 border h-full w-full inline" v-model="contactData.middle_name">
                </div>
                    <div class="flex justify-start py-0.5">
                    <div class="h-fit whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Last Name:</div>
                </div>
                <div class="flex space-x-1 2xl:col-span-3 w-full">
                    <input type="text" required class="p-1 border h-full w-full inline" v-model="contactData.last_name">
                </div>
                    <div class="flex justify-start py-0.5">
                    <div class="h-fit whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Suffix:</div>
                </div>
                <div class="flex space-x-1 2xl:col-span-3 w-full">
                    <input type="text" required class="p-1 border h-full w-full inline" v-model="contactData.suffix">
                </div>
                <div class="flex justify-start py-0.5">
                    <div class="h-fit whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Personal Email:</div>
                </div>
                <div class="flex space-x-1  w-full 2xl:col-span-3">
                    <input type="email" class="p-1 border h-full w-full" v-model="contactData.personal_email">
                </div>
                <div class="flex justify-start py-0.5">
                    <div class="h-fit whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Personal Cell Phone:</div>
                </div>
                <div class="flex space-x-1 w-full 2xl:col-span-3">
                    <input type="tel" maxlength="50" class="p-1 border h-full w-full" v-model="contactData.personal_phone">
                </div>
                <div class="flex justify-start py-0.5">
                    <div class="h-fit whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Linkedin:</div>

                </div>
                <div class="flex space-x-1  w-full 2xl:col-span-3">
                    <input inputType="url" class="p-1 border h-full w-full" v-model="contactData.linkedin_profile">
                </div>
                <div class="flex justify-start py-0.5">
                    <div class="h-fit whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Personal Notes:</div>
                </div>
                <div class="w-full 2xl:col-span-3">
                    <textarea class="p-1 border h-full w-full" v-model="contactData.personal_notes"></textarea>
                </div>
            </div>
            <div class="flex flex-col xl:grid xl:gap-1 xl:grid-cols-2 2xl:grid-cols-4 items-start px-3">
                <div class="flex justify-start  py-0.5">
                    <div class="h-fit whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Title:</div>
                </div>
                <div class="flex space-x-1 2xl:col-span-3 w-full">
                    <input type="text" required class="p-1 border h-full w-full" v-model="companyRelationshipData.title">
                </div>
                <div class="flex justify-start  py-0.5">
                    <div class="h-fit whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Company Direct Line:</div>
                </div>
                <div class="flex space-x-1  2xl:col-span-3 w-full">
                    <input inputType="tel" maxlength="50" required class="p-1 border h-full w-full" v-model="companyRelationshipData.phone_number">
                </div>
                <div class="flex justify-start  py-0.5 ">
                    <div class="h-fit whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Outreach Email:</div>
                </div>
                <div class="flex space-x-1 2xl:col-span-3 w-full">
                    <input inputType="email" required class="p-1 border h-full w-full" v-model="companyRelationshipData.email_address">
                </div>
                <div class="flex justify-start  py-0.5">
                    <div class="h-fit whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Contact Notes:</div>
                </div>
                <div class="2xl:col-span-3 w-full">
                    <textarea class="p-1 border h-full w-full" v-model="companyRelationshipData.contact_notes"></textarea>
                </div>
                <div class="flex justify-start  py-0.5">
                    <div class="h-fit whitespace-nowrap font-semibold tracking-wide text-gray-800 pr-0">Is Primary:</div>
                </div>
                <div class="flex space-x-1 2xl:col-span-3 w-full">
                    <select name="isPrimaryContact" v-model="companyRelationshipData.is_primary_contact" class="p-1 border h-full w-full" id="">
                    <option :value="true">True</option>
                    <option :value="false" selected>False</option>
                </select>
                </div>
                <div class="flex flex-row space-x-2 col-span-4 my-1.5 justify-end w-full">
                    <base-button-affirmative @click="addContact">Save</base-button-affirmative>
                    <base-button-negative @click="closeForm">Cancel</base-button-negative>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "company-contact-form"
    }
</script>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
import { createContactAndCompanyRelationship } from '@/services/Contact';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';

    const store = useStore()
    const $toast = useToast()

    const props = defineProps({
        company: Object
    })

    const emit = defineEmits(['refetch-companies', 'close-form'])

    const contactData = ref({
        prefix: null,
        first_name: null,
        middle_name: null,
        last_name: null,
        suffix: null,
        personal_phone: null,
        personal_email: null,
        linkedin_profile: null,
        personal_notes: null,
    })

    const companyRelationshipData = ref({
        email_address: null,
        contact_notes: null,
        title: null,
        phone_number: null,
        is_primary_contact: false,
        status: "active",
        company_id: props.company.id
    })

    function closeForm(){
        emit('close-form')
    }

    async function addContact(){
        const token = store.state.auth.token
        let errorMessage = "Error, missing "
        if(!contactData.value.first_name || !contactData.value.last_name){
            if(!contactData.value.action_name){
                errorMessage += "first name "
            }
            if(!contactData.value.last_name){
                errorMessage += "last name "
            }
            alert(errorMessage)
            return
        }
        const data = {
            "contact": contactData.value,
            "company_relationship": companyRelationshipData.value
        }
        // console.log('form data', data)
        const response = await createContactAndCompanyRelationship(data, token)
        // console.log('response', response)
        if (response.status == 200){
            $toast.open(
                {
                    message: `Contact created for ${props.company.company_name}`,
                    type: 'success',
                    duration: 20000
                }
            )
            emit('refetch-companies')
            emit('close-form')
        } else {
            $toast.open(
                {
                    message: `${response.response.data.detail}`,
                    type: 'error',
                    duration: 20000
                }
            )
        }
    }


</script>